import api from '../api';

export const fetchMeetingAvailability = async (meetingId, anchorDate = null) => {
  try {
    const formattedAnchorDate =
      anchorDate instanceof Date
        ? `${anchorDate.getFullYear()}-${String(anchorDate.getMonth() + 1).padStart(2, '0')}-${String(
            anchorDate.getDate()
          ).padStart(2, '0')}`
        : anchorDate;

    const response = await api.get(`/meetings/${meetingId}/availability`, {
      params: formattedAnchorDate
        ? {
            anchor_date: formattedAnchorDate,
          }
        : {},
    });
    return response;
  } catch (error) {
    console.error('Error fetching meeting availability:', error);
    throw error;
  }
};

export const fetchAvailabilityPreview = async (userIds, anchorDate = null) => {
  try {
    const formattedAnchorDate =
      anchorDate instanceof Date
        ? `${anchorDate.getFullYear()}-${String(anchorDate.getMonth() + 1).padStart(2, '0')}-${String(
            anchorDate.getDate()
          ).padStart(2, '0')}`
        : anchorDate;

    const params = new URLSearchParams();
    if (userIds && userIds.length > 0) {
      userIds.forEach(id => params.append('user_ids[]', id));
    }
    if (formattedAnchorDate) {
      params.append('anchor_date', formattedAnchorDate);
    }

    const response = await api.get(`/meetings/availability/preview?${params.toString()}`);
    return response;
  } catch (error) {
    console.error('Error fetching availability preview:', error);
    throw error;
  }
};

export default {
  fetchMeetingAvailability,
  fetchAvailabilityPreview,
};
